import axios from '@/libs/axios'
import { ApiCode, ApiExtRoutes } from '@/const/api'
import { handleCatch } from '@/utils'

export const baseAttr = Object.freeze({
  basePath: ApiExtRoutes.setOfCriteriaTypes,
})
export default {
  namespaced: true,
  state: {
    dataSources: [],
    totalRows: 0,
    dataResourecesExport: [],
    factSetOfCriteriaTypes: [],
  },
  getters: {
    dataSources: state => state.dataSources,
    totalRows: state => state.totalRows,
    dataResourecesExport: state => state.dataResourecesExport,
    factSetOfCriteriaTypes: state => state.factSetOfCriteriaTypes,
  },
  mutations: {
    SET_DATA_SOURCES: (state, data) => { state.dataSources = data },
    SET_TOTAL_ROWS: (state, data) => { state.totalRows = data },
    SET_DATA_SOURCES_EXPORT: (state, data) => { state.dataResourecesExport = data },
    SET_FACT_SET_OF_CRITERIA_TYPES: (state, data) => { state.factSetOfCriteriaTypes = data },
  },
  actions: {
    async begin({ commit }, params) {
      try {
          const response = await axios.get(`${baseAttr.basePath}/begin`, { params })
          const { data } = response
          if (data.code === ApiCode.SUCCESS) {
              const { factSetOfCriteriaTypes } = data.data
              commit('SET_FACT_SET_OF_CRITERIA_TYPES', factSetOfCriteriaTypes)
          }
      } catch (e) {
          handleCatch(e)
      }
    },
    async getDataSources({ commit }, params) {
      try {
        const response = await axios.get(baseAttr.basePath, { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          const { total, records } = data.data
          commit('SET_DATA_SOURCES', records)
          commit('SET_TOTAL_ROWS', total)
        }
      } catch (e) {
        handleCatch(e)
      }
    },

    async createDataSource({ commit }, params) {
      try {
        const response = await axios.post(baseAttr.basePath, params)
        const { data } = response
        const isSuccessful = data.code === ApiCode.SUCCESS
        if (isSuccessful) {
          return { isSuccessful, message: data.message }
        }
        return { isSuccessful, message: data.debugMessage }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },

    async updateDataSource({ commit }, params) {
      try {
        const response = await axios.put(`${baseAttr.basePath}/${params.id}`, params)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },

    async deleteDataSource({ commit }, id) {
      try {
        const response = await axios.delete(`${baseAttr.basePath}/${id}`)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },

    async importSetOfCriteriaType({ commit }, params) {
      try {
          const response = await axios.post(`${baseAttr.basePath}/importSetOfCriteriaType`, { params })
          const { data } = response
          return data;
      } catch (e) {
          handleCatch(e)
      }
    },

    async getDataSourcesExport({ commit }, params) {
      try {
        const response = await axios.get(baseAttr.basePath, { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          const { records } = data.data
          commit('SET_DATA_SOURCES_EXPORT', records)
        }
      } catch (e) {
        handleCatch(e)
      }
    },
  },
}
